'use strict';

import angular from 'angular';

export default class FormCtrl {
  submitted = false;

  // date input types
  maxDays = {
    0: '31', // Jan,
    1: '29', // Feb,
    2: '31', // March,
    3: '30', // April,
    4: '31', // May,
    5: '30', // June,
    6: '31', // July,
    7: '31', // Aug,
    8: '30', // Sept,
    9: '31', // Oct,
    10: '30', // Nov,
    11: '31', // Dec
  };

  constructor($scope, $state) {
    // attach parent vm
    var parentModel = $state.$current.self.controllerAs || 'vm';
    this.parentvm = $scope.$parent[parentModel] || {};

    // date picker
    this.dateOpen = {};
    this.openDatepicker = function($event, value) {
      $event.preventDefault();
      $event.stopPropagation();
      this.dateOpen[value] = true;
    };
  }

  /**
   *  TODO: check if alerts are still in use anywhere
   */
  closeAlert(index) {
    this.alerts.splice(index, 1);
  }

  submitForm(form) {
    this.submitted = true;
    // setPristine to
    // 1. disable submit/prevent submission without fixing errors
    // 2. reset form if success & staying on the same page
    form.$setPristine();
    var that = this;

    /**
     * TODO: convert from database to neo4j
     */
    var errorCb = function(err) {
      that.submitted = true;
      // Update validity of form inputs with server/database errors
      if(err && err.data && err.data.errors) {
        if(!that.errors) { that.errors = {}; }
        var errors = err.data.errors;
        angular.forEach(errors, function(error, input) {
          if(input === 'emails') { input = 'email'; }
          form[input].$setValidity('database', false);
          that.errors[input] = error.message;
        });
      }
    };

    if(form.$valid) {
      // reset form submission if stay on same page;
      this.submitted = false;
      this.parentvm.submit(errorCb, form);
    }
  }
}

FormCtrl.$inject = ['$scope', '$state'];
